import React from "react";
import ReactTable from 'react-table-v6'
import { toast, } from 'react-toastify';
import '../../assets/css/Table.css'
import RegularButton from "../CustomButtons/Button.jsx";
import { NavLink } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import GridContainer from "../Grid/GridContainer.jsx";
import GridItem from "../Grid/GridItem.jsx";
import Card from "../Card/Card.jsx";
import CardBody from "../Card/CardBody.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import axios from 'axios'
import Search from '../../assets/img/search_icon2x.png'
import Reset from '../../assets/img/icons8-delete-26.png'
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Datetime from 'react-datetime';
import ExportTo from '../Common/ExportTo'
import CustomSelect from '../Common/CustomSelect'
import CustomDialog from '../Common/CustomDialog'
import { BASE_URL } from "../../utils/handleApi";

const styles = theme => ({
  button: {
      marginLeft: "10px",
      color: 'white',
      backgroundColor: '#04ab23',
      textTransform: 'none',
      fontFamily: 'Roboto-Medium',
      boxShadow: "none",
      borderRadius: 1,
      width: '100px',
      fontSize: "17px",
      '&:hover': {
        backgroundColor: '#04ab23'
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#04ab23'
      },
    },

  select: {
      width: '12vw',
      height: "26px",
      border: 'none',
      boxShadow: '0px 0px 5px 0px #d6d6d6',
      // [theme.breakpoints.down('xs')]: {
      //   width: '40vw',

      // },
    },
  cardIconTitle: {
      ...cardTitle,
      marginTop: "10px",
      [theme.breakpoints.down('xs')]:{
          marginTop:"25%"
      }
  },
  headerBlock: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]:{
      justifyContent: 'center'
    }
  }
});
class ReactTables extends React.Component {
  state = {
    loading: false,
    arrOrders:[],
    showDialogForDelete : false,
    search_text: '',
    search_type: '',
    originalTable: [],
    filterApplied: false,
    search_field_type: "text",
    openDialogWhenNoData: false
  };
   
  componentDidMount() {
    this.setState({ loading: true })
    axios.post(`${BASE_URL}/order/all`, {
      'lender_id': this.props.lenderId    
    })
    .then(res => {
      this.setState({ arrOrders: res.data, loading: false, originalTable: res.data  })
    })
    .catch(() => {
      this.setState({ loading: false })
      toast.error('Some error happened!')
    })
    }

  handleYes = () => {
    const { idToDelete, arrOrders } = this.state;
    const tokenStr = localStorage.getItem('token');
      axios.post(`${BASE_URL}/order/delete`, {
        'order_id': idToDelete
      },{
        headers:{
          'Authorization': `Bearer ${tokenStr}`,
        }
      })
      .then(() => {
        let orders = arrOrders;
        orders = orders.filter(order => order.id !== idToDelete);
        this.setState({
            arrOrders: orders, 
            showDialogForDelete: false 
        }, () => {
            toast.success('Order deleted successfully!')
        });
      })
      .catch(() => {
        toast.error('Some error happened!')
      })
    }

  handleChange = e => {
    if(e.target.value.includes("date")){
      this.setState({ search_field_type: 'date', search_text: moment().format('MM/DD/YYYY')})
    } else {
      this.setState({ search_field_type: 'text', search_text: ''})
    }
    this.setState({ [e.target.name]: e.target.value })
  }

  searchTable = () => {
    let { search_text, search_type } = this.state;
    let tokenStr = localStorage.getItem("token");

    const body = {
      key_name: search_type,
      search_text: search_text
    }

    this.setState({ loading: true })
    axios.post(`${BASE_URL}/order/search`, body, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
      },
    })
    .then((res) => {
      if(search_type === "lender"){
        const removeFalsyLenders = res.data.filter(order => order.lender_id !== null)
        return this.setState({ loading: false, arrOrders: removeFalsyLenders, filterApplied: true, })
      }
      if(search_type === "product"){
        const removeFalsyProducts = res.data.filter(order => order.search_products_type !== null)
        return this.setState({ loading: false, arrOrders: removeFalsyProducts, filterApplied: true, })
      }
      this.setState({ loading: false, arrOrders: res.data, filterApplied: true, })
    })
    .catch(err => {
      this.setState({ loading: false })
      toast.error('Some error happened!')
    })
  }

  resetFilter = () => {
    const { originalTable } = this.state;
    this.setState({ 
      arrOrders: originalTable,
      search_text: "",
      search_type: "",
      filterApplied: false,
      search_field_type: 'text'
    })
  }

  exportPDF = () => {
    const { arrOrders, originalTable, openDialogWhenNoData } = this.state;
      if(arrOrders.length === 0){
        return this.setState({ openDialogWhenNoData: !openDialogWhenNoData })
      }
      else {
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";

        const marginLeft = 20;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "My Orders";
        const headers = [["Order No.", "Borrower Business Name", "Borrower Name", "Order Date", "Order Due Date", "Order Completed Date", "Product Name", "Address" ]];
        
        const data = (arrOrders.length < originalTable.length ? arrOrders : originalTable).map((prop, key) => ([
          prop.order_no,
          prop.borrower?.business_name || "N/A",
          prop.borrower?.name || "N/A",
          prop.order_date,
          prop.due_date,
          prop.completed_date || "N/A",
          prop.search_products_type?.name || "N/A",
          `${prop.location?.street_address} ${prop.location?.city} ${prop.location?.state} ${prop.location?.zip}`,
        ]))

        let content = {
          startY: 50,
          head: headers,
          body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save(`orders_${moment().format('LLL')}`)
      }
  }

  exportExcel = () => {
    if(this.state.arrOrders.length === 0){
      this.setState({ openDialogWhenNoData: !this.state.openDialogWhenNoData });
      return false
    }
    return true
  }

  render() {
    const { classes } = this.props;
    const { arrOrders, originalTable, filterApplied, loading, search_text, search_type, search_field_type, showDialogForDelete, openDialogWhenNoData } = this.state;

    const tempOrders = (arrOrders.length < originalTable.length ? arrOrders : originalTable).map((order) => {
      const completedDate = order.logs?.order_status.filter(order_stat => order_stat.status === "Completed")[0]?.done_on
      return {
        id: order.id,    
        order_no: order.order_no,
        bo_business_name: order.borrower.business_name || "N/A",
        bo_name: order.borrower.name || "N/A",
        order_date: moment(order.order_date).format("MM/DD/YYYY"),
        order_due_date: moment(order.due_date).format("MM/DD/YYYY"),
        completed_date: completedDate !== undefined ? moment(completedDate).format("MM/DD/YYYY") : "N/A",
        product: order.search_products_type?.name || "N/A",
        address: `${order.location.street_address} ${order.location.city} ${order.location.state} ${order.location.zip}`,
        attachments:  (<NavLink to={{
          pathname: `/Attachments/${order.id}`,
          state: { comp_order: false}}}
        style={{color:"#04ab23"}}>
        <p style={{textAlign: "center",textDecorationLine: 'underline'}}>View</p></NavLink>),
        actions: (
          <div className="actions-right">
            <NavLink to={{
              pathname: `/MyLenders/orders/${this.props.lenderId}/edit/${order.id}`,
              state: {
                lender_clientNo: this.props.lenderClientNo,
                lender_name: this.props.lenderName
              }
            }}>
              <Button className="Edit">
                <Tooltip title="Edit"> 
                  <EditIcon />
                </Tooltip>
              </Button>{" "}
            </NavLink>
            <Button
              onClick={() => this.setState({ showDialogForDelete: true, idToDelete: order.id })}
              className="remove">
                <Tooltip title="Delete"> 
                  <Close />
                </Tooltip>
            </Button>{" "}
          </div>
        )
      };
    });
    
    const dataExcel = (arrOrders.length < originalTable.length ? arrOrders : originalTable).map((prop, key) => {
      return {
          "Order No.": prop.order_no,
          "Borrower Business Name": (prop.borrower && prop.borrower.business_name) || "N/A",
          "Borrower Name": (prop.borrower && prop.borrower.name) || "N/A",
          "Order Date": prop.order_date,
          "Order Due Date": prop.due_date,
          "Order Completed Date": prop.completed_date || "N/A",
          "Product Name": prop.search_products_type?.name || "N/A",
          Address: `${prop.location?.street_address} ${prop.location?.city} ${prop.location?.state} ${prop.location?.zip}`,
      };
    })

    
    return (
      <GridContainer style={{width:'80vw', margin: '0 auto'}}>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <div className={classes.cardIconTitle}>
                <Grid container>
                  <Grid container item xs={12} md={8} className={classes.headerBlock}>
                    <h4 style={{margin: "0 1rem 0 0"}}>Search By</h4>
                    <CustomSelect
                      name={'search_type'}
                      disabled={filterApplied}
                      value={search_type}
                      handleChange={this.handleChange}
                      options={[
                        {name: 'Select Type', value: ''},
                        {name: 'Order No', value: 'order_no'},
                        {name: 'Borrower Business Name', value: 'borrower.business_name'},
                        {name: 'Borrower Name', value: 'borrower.name'},
                        {name: 'Order Date', value: 'order_date'},
                        {name: 'Order Due Date', value: 'due_date'},
                        {name: 'Lender', value: 'lender'},
                        {name: 'Product', value: 'product'},
                        {name: 'Address', value: 'address'},
                      ]}
                    />
                    <h4 style={{margin: "0 1rem"}}>Lookup</h4>
                    {search_field_type === "text" && (
                      <input 
                        name="search_text"
                        type="text"
                        value={search_text}
                        onChange={this.handleChange}
                        id="search" 
                        className={classes.select1}
                        disabled={filterApplied || !search_type}
                      />
                    )}
                    {search_field_type === "date" && (
                      <Datetime
                        id="search"
                        className="filter-date-picker"
                        closeOnSelect
                        timeFormat={false}
                        value={search_text}
                        initialValue={new Date()}
                        onChange={event => {
                          return this.setState({ search_text: event.format('MM/DD/YYYY')})
                        }}
                        inputProps={{
                          disabled: filterApplied || !search_type,
                        }}
                      />
                    )}
                    <RegularButton
                      onClick={filterApplied ? () => this.resetFilter() : () => this.searchTable()}
                      disabled={!filterApplied && (!search_type || !search_text) ? true : false}
                      variant="contained"
                      className={classes.button}
                      style={filterApplied ? {backgroundColor: "#e45252"} : {}}
                      endIcon={
                        <img 
                          src={filterApplied ? Reset : Search}
                          alt={filterApplied ? 'Reset' : 'Search'}
                          style={{height: "20px", width: "20px"}} 
                        />
                      }
                    >
                      {filterApplied ? 'Reset' : 'Search'}
                    </RegularButton>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ExportTo 
                      fileName={'orders'}
                      exportPDF={this.exportPDF}
                      exportExcel={this.exportExcel}
                      dataExcel={dataExcel}
                    />
                  </Grid>
                </Grid>
              </div>
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>{originalTable.length === 0 ? `No Orders available` : `No data found`}</p>}
                data={tempOrders}
                columns={[
                  {
                    Header: "Order No",
                    accessor: "order_no",
                  },
                  {
                    Header: "Borrower Business Name",
                    accessor: "bo_business_name",
                  },
                  {
                    Header: "Borrower Name",
                    accessor: "bo_name",
                  },
                  {
                    Header: "Order Date",
                    accessor: "order_date",
                  },
                  {
                    Header: "Order Due Date",
                    accessor: "order_due_date",
                  },
                  {
                    Header: "Order Completed Date",
                    accessor: "completed_date",
                  },
                  {
                    Header: "Product",
                    accessor: "product",
                  },
                  {
                    Header: "Address",
                    accessor: "address",
                  },
                  {
                    Header: "Attachments",
                    accessor: "attachments",
                    
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    headerStyle: { textAlign: 'center' },
                    width: 150,
                  }
                ]}
                sortable={false}
                style={{ width: '99%', border: 'none', whiteSpace: 'unset', marginLeft: 'auto', marginRight: 'auto' }}
                defaultPageSize={10}
                minRows={0}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
                getTrGroupProps={() => {
                  return {
                    style: {
                      borderBottom: "1px solid #d6d6d6",
                    }
                  }
                }}
                getPaginationProps={() => ({ style: { boxShadow: 'none', border: 'none' }})}
              />
              <Grid container justify="center" style={{marginTop: "2.5em"}}>
                <Grid item>
                  <div className={classes.root}>
                    <NavLink to={{
                      pathname: `/MyLenders/orders/${this.props.lenderId}/add`,
                      state: {
                        lender_clientNo: this.props.lenderClientNo,
                        lender_name: this.props.lenderName
                    }}}>
                      <div className={classes.rootButton}>
                        <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                          Add Order
                        </Button>
                      </div>
                  </NavLink>
                  </div>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </GridItem>
        <Dialog
          className={classes.dialog}
          open={showDialogForDelete}
          onClose={() => this.setState({ showDialogForDelete: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{backgroundColor: "green", fontSize: "18px", color: "white"}}>
          <p style={{color: "white"}}>Please Confirm </p></DialogTitle>
          <DialogContent style={{marginTop: "10px"}}>Are you sure you want to <b> delete this Order?</b></DialogContent>
          <DialogActions>
            <RegularButton onClick={() => this.setState({ showDialogForDelete: false })} color="danger" >
            No
            </RegularButton>
            <RegularButton onClick={this.handleYes} color="success" autoFocus>
            Yes
            </RegularButton>
          </DialogActions>
        </Dialog>
        <CustomDialog 
          openDialog={openDialogWhenNoData}
          closeDialog={() => this.setState({ openDialogWhenNoData: !openDialogWhenNoData })}
        />
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ReactTables);
